module.exports = __webpack_public_path__ + "a83cf184651b9f09bafcdca2619006e8.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/Donut.png
// module id = 1831
// module chunks = 0